import { DailyNavSetupMeasurementDate, DailyNavSetupPreviousValuation, FirmDailyNavCompanyConfigRow } from 'api';

export enum DailyNavSetupStep {
  MARKET = 'market',
  THRESHOLDS = 'thresholds',
  DELIVERY = 'delivery',
  COMPANIES = 'companies',
  REVIEW = 'review',
}

export const DAILY_NAV_SETUP_STEPS: { key: DailyNavSetupStep; label: string }[] = [
  { key: DailyNavSetupStep.MARKET, label: 'Market & schedule' },
  { key: DailyNavSetupStep.THRESHOLDS, label: 'Alert thresholds' },
  { key: DailyNavSetupStep.DELIVERY, label: 'Reports & delivery' },
  { key: DailyNavSetupStep.COMPANIES, label: 'Companies' },
  { key: DailyNavSetupStep.REVIEW, label: 'Review' },
];

// Steps that need a saved firm config before they can open.
export const COMPANY_STEPS = new Set([DailyNavSetupStep.COMPANIES, DailyNavSetupStep.REVIEW]);

export enum CompanySetupStatus {
  READY = 'ready',
  NEEDS_ALEXANDRIA = 'needs_alexandria',
  EXCLUDED = 'excluded',
}

export const COMPANY_SETUP_STATUS_LABELS: Record<CompanySetupStatus, string> = {
  [CompanySetupStatus.READY]: 'Ready',
  [CompanySetupStatus.NEEDS_ALEXANDRIA]: 'Needs external company profile',
  [CompanySetupStatus.EXCLUDED]: 'Excluded',
};

// Ready = included and linked to its own external company profile. Comps are encouraged
// but do not gate it; excluded companies never block completion.
export const companySetupStatus = (row: FirmDailyNavCompanyConfigRow): CompanySetupStatus => {
  if (!row.monitoring_enabled) {
    return CompanySetupStatus.EXCLUDED;
  }
  return row.alexandria_id ? CompanySetupStatus.READY : CompanySetupStatus.NEEDS_ALEXANDRIA;
};

// Whether the setup endpoint's valuation/GPC data is known yet: "none" must not be
// shown while it is still loading or failed to load.
export type SetupDataState = 'loading' | 'error' | 'ready';

// The generated type drops the null (drf_yasg emits nested fields as a bare $ref).
export type PreviousValuation = DailyNavSetupPreviousValuation | null;
export type SetupMeasurementDate = DailyNavSetupMeasurementDate | null;
